export enum SizesEnum {
  l = 'l',
  m = 'm'
}

export enum DirectionEnum {
  column = 'column',
  row = 'row'
}

export type Sizes = SizesEnum.l | SizesEnum.m
export type Direction = DirectionEnum.column | DirectionEnum.row
